import {
  APPROVE_ORDER_REQUEST,
  APPROVE_ORDER_SUCCESS,
  APPROVE_ORDER_FAIL,
} from "../actionTypes";
import {
  PROCESS_ORDER_REQUEST,
  PROCESS_ORDER_SUCCESS,
  PROCESS_ORDER_FAIL,
} from "../actionTypes";
import axiosInstance from "../../api/axiosInstance";
import { submitPayment } from "./orderActions";
import { toast } from "react-toastify";
// export const processOrder = (orderId, amount, token) => async (dispatch) => {
//   try {
//     dispatch({ type: PROCESS_ORDER_REQUEST });

//     const response = await axiosInstance.post(
//       `/api/payment/${orderId}/`, // <-- Use backticks for template literal
//       { amount: amount },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     const paymentId = response.data.data.payment_id; // Get the payment_id
//     console.log("Payment ID:", paymentId); // Log the payment_id
//     dispatch(submitPayment(orderId, { payment_id: paymentId }, token)); // Pass payment_id

//     dispatch({
//       type: PROCESS_ORDER_SUCCESS,
//       payload: response.data.data,
//     });
//   } catch (error) {
//     console.error("Process order failed:", {
//       message: error.message,
//       response: error.response?.data,
//       status: error.response?.status,
//     });

//     dispatch({
//       type: PROCESS_ORDER_FAIL,
//       payload: error.response ? error.response.data : error.message,
//     });
//   }
// };
// OrderApproveAction.js
export const processOrder = (orderId, amount, token) => async (dispatch) => {
  try {
    dispatch({ type: PROCESS_ORDER_REQUEST });

    // Make the request to initiate the payment
    const response = await axiosInstance.post(
      `/api/payment/${orderId}/`, // This API call will include payment_id in its response
      { amount: amount },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Log the entire response to ensure payment_id is present
    console.log("Process order response:", response);

    // Extract the payment_id from the response
    const paymentId = response.data.payment_id; // payment_id is directly in the response data

    if (!paymentId) {
      throw new Error("Payment ID not found in the response.");
    }

    // Log the payment_id for debugging purposes
    console.log("Extracted payment_id:", paymentId);

    // Now dispatch submitPayment action with the extracted payment_id
    dispatch(submitPayment(paymentId, { amount: amount }, token));

    dispatch({
      type: PROCESS_ORDER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Process order failed:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });

    dispatch({
      type: PROCESS_ORDER_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
  }
};

export const approveOrder = (orderId, token) => async (dispatch) => {
  try {
    dispatch({ type: APPROVE_ORDER_REQUEST });

    const response = await axiosInstance.post(
      "/api/approve-order/",
      { order_id: orderId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const paymentId = response.data.payment_id; // Get payment_id directly from the response

    console.log("Payment ID:", paymentId); // Log the payment_id for debugging

    dispatch({
      type: APPROVE_ORDER_SUCCESS,
      payload: response.data.data, // Assuming API returns the updated order data
    });
    const successMessage =
      response.data.message ||
      "Order Approved successfully";
    toast.success(successMessage);
  } catch (error) {
    dispatch({
      type: APPROVE_ORDER_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to Approve order";
    toast.error(errorMessage);
  }
};
